import './menstrual-culture-definition.css'

import aperturaEncuentro from '../../../assets/img/cultura-menstrual-galeria/Apertura del encuentro con Carolina Ackermann Barreiro_Viernes 31 de mayo de 2019.jpg'
import lidiaUve from '../../../assets/img/cultura-menstrual-galeria/Cantautora Lidia Uve_Viernes 31 de mayo de 2019.jpg'
import cierreEncuentro from '../../../assets/img/cultura-menstrual-galeria/Cierre del encuentro con Diana Pinzón Sanabria_Sábado 01 de junio de 2019.jpg'
import coorganizadoras from '../../../assets/img/cultura-menstrual-galeria/Co-organizadoras 1er EnCuMe.jpg'
import comidaCompartida from '../../../assets/img/cultura-menstrual-galeria/Comida compartida_La Bonne_Sábado 01 de junio de 2019.jpg'
import cristinaAmba from '../../../assets/img/cultura-menstrual-galeria/Cristina de Amba (Menstruacion Digna) en streaming.jpg'
import colaboradoras from '../../../assets/img/cultura-menstrual-galeria/Dos de las colaboradoras_ Rocío Remuiñan y Mariana Cortéz.jpg'
import fotoGrupal from '../../../assets/img/cultura-menstrual-galeria/Foto grupal asistentes al 1er EnCuMe.jpg'
import mesaRedonda from '../../../assets/img/cultura-menstrual-galeria/Mesa redonda internacional_Sábado 01 de junio de 2019.jpg'
import ponenciaCarme from '../../../assets/img/cultura-menstrual-galeria/Ponencia de la Dra. Carme Valls-Llobet_Sábado 01 de junio de 2019.JPG'
import presentacionProyectos from '../../../assets/img/cultura-menstrual-galeria/Presentación de compañeras y proyectos.jpg'
import revistas from '../../../assets/img/cultura-menstrual-galeria/Revistas Mujeres y Salud_CAPS.jpg'
import totiBaches from '../../../assets/img/cultura-menstrual-galeria/Toti Baches nos habló de su película.jpg'

const culturePhotos = [
  { image: aperturaEncuentro, alt: 'Apertura del encuentro con Carolina Ackermann Barreiro', caption: 'Apertura del encuentro con Carolina Ackermann Barreiro' },
  { image: lidiaUve, alt: 'Cantautora Lidia Uve', caption: 'Cantautora Lidia Uve' },
  { image: cierreEncuentro, alt: 'Cierre del encuentro con Diana Pinzón Sanabria', caption: 'Cierre del encuentro con Diana Pinzón Sanabria' },
  { image: coorganizadoras, alt: 'Co-organizadoras 1er EnCuMe', caption: 'Co-organizadoras 1er EnCuMe' },
  { image: comidaCompartida, alt: 'Comida compartida La Bonne', caption: 'Comida compartida La Bonne' },
  { image: cristinaAmba, alt: 'Cristina de AMBA (Menstruación Digna) en streaming', caption: 'Cristina de AMBA (Menstruación Digna) en streaming' },
  { image: colaboradoras, alt: 'Dos de las colaboradoras: Rocío Remuiñan y Mariana Cortéz', caption: 'Dos de las colaboradoras: Rocío Remuiñan y Mariana Cortéz' },
  { image: fotoGrupal, alt: 'Foto grupal asistentes al 1er EnCuMe', caption: 'Foto grupal asistentes al 1er EnCuMe' },
  { image: mesaRedonda, alt: 'Mesa redonda internacional', caption: 'Mesa redonda internacional' },
  { image: ponenciaCarme, alt: 'Ponencia de la Dra. Carme Valls-Llobet', caption: 'Ponencia de la Dra. Carme Valls-Llobet' },
  { image: presentacionProyectos, alt: 'Presentación de compañeras y proyectos', caption: 'Presentación de compañeras y proyectos' },
  { image: revistas, alt: 'Revistas Mujeres y Salud CAPS', caption: 'Revistas Mujeres y Salud CAPS' },
  { image: totiBaches, alt: 'Toti Baches nos habló de su película', caption: 'Toti Baches nos habló de su película' }
]

export default function MenstrualCultureGallery() {
  return (
    <section className='menstrual-culture-gallery-section' aria-labelledby='menstrual-culture-gallery-title'>
      <div className='menstrual-culture-gallery-section__container'>
        <div className='menstrual-culture-gallery-section__header'>
          <p className='menstrual-culture-gallery-section__eyebrow'>Memoria visual</p>
          <h2 id='menstrual-culture-gallery-title'>Galería del I EnCuMe</h2>
        </div>
        <div className='menstrual-culture-definition-section__gallery' aria-label='Galería de fotos del I Encuentro de Cultura Menstrual'>
          {culturePhotos.map(({ image, alt, caption }) => (
            <figure key={alt} className='menstrual-culture-definition-section__gallery-item'>
              <img src={image} alt={alt} />
              <figcaption>{caption}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}
